import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { HealthfairService } from '../../services/healthfair/healthfair.service';
import { HealthFairDtls } from '../../../models/healthfair/HealthFairDtls';

export const HealthfairResourceResolver:ResolveFn<Observable<HealthFairDtls>> = (route, state) => {
  return inject(HealthfairService).getInitialDtls();
};
